export default {
    "WELCOME_PATIENT": "welcome-patient",
    'LOGIN_PATIENT': 'login-patient',
    "PATIENT_DATA": "patient-data",
    "QUESTION": "question",
    "PATIENT_INFORMATION_SHEET": "patient-information-sheet",
    "GOODBY_PATIENT": "goodby-patient"
}